import type { UpdateNotificationSettingsBodyFrequency } from './updateNotificationSettingsBodyFrequency';
import type { UpdateNotificationSettingsBodyTypeSettings } from './updateNotificationSettingsBodyTypeSettings';

export type UpdateNotificationSettingsBody = {
  emailEnabled?: boolean;
  frequency?: UpdateNotificationSettingsBodyFrequency;
  inAppEnabled?: boolean;
  pushEnabled?: boolean;
  /** @nullable */
  quietHoursEnd?: string | null;
  /** @nullable */
  quietHoursStart?: string | null;
  smsEnabled?: boolean;
  typeSettings?: UpdateNotificationSettingsBodyTypeSettings;
  userId: string;
};
